export default __webpack_public_path__ + "media/images/lp/pop-b12ef121a1e97a507e396551288882f4.png";